import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { BudgetRoutingModule } from './budget-routing.module';
import { BudgetComponent } from '../components/budget/budget.component';
import { ImportsPrimeModule } from 'src/app/_material/primeng.module';
import { SharedComponentsModule } from '../../shared/shared-components/shared-components.module';
import { AddBudgetComponent } from '../components/add-budget/add-budget.component';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';


@NgModule({
  declarations: [
    BudgetComponent,
    AddBudgetComponent
  ],
  imports: [
    CommonModule,
    BudgetRoutingModule,
    FormsModule,
    ImportsPrimeModule,
    DatePipe,
    SharedModule,
    SharedComponentsModule
  ]
})
export class BudgetModule { }
